// extracted by mini-css-extract-plugin
module.exports = {"scrollBody":"TermsAndConditionsModal-ScrollBody-module--scroll-body--1wLZV"};